;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"5d949c8d78a3f311587ae9215eb74b98ff3b2034"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/hcp";globalThis["_sentryAssetPrefix"] = "/hcp";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:cacheKey\",\"regex\":\"^/([^/]+)$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/:slug*\",\"regex\":\"^/([^/]+)/(.+)$\",\"paramNames\":[\"cacheKey\",\"slug\"]},{\"path\":\"/:cacheKey/help\",\"regex\":\"^/([^/]+)/help$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/help/:slug*\",\"regex\":\"^/([^/]+)/help/(.+)$\",\"paramNames\":[\"cacheKey\",\"slug\"]},{\"path\":\"/:cacheKey/learning-center\",\"regex\":\"^/([^/]+)/learning-center$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/learning-center/:species\",\"regex\":\"^/([^/]+)/learning-center/([^/]+)$\",\"paramNames\":[\"cacheKey\",\"species\"]},{\"path\":\"/:cacheKey/learning-center/:species/:article*\",\"regex\":\"^/([^/]+)/learning-center/([^/]+)/(.+)$\",\"paramNames\":[\"cacheKey\",\"species\",\"article\"]},{\"path\":\"/:cacheKey/local-ad\",\"regex\":\"^/([^/]+)/local-ad$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/shop-by-brand\",\"regex\":\"^/([^/]+)/shop-by-brand$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/store-locator\",\"regex\":\"^/([^/]+)/store-locator$\",\"paramNames\":[\"cacheKey\"]},{\"path\":\"/:cacheKey/stores/:country\",\"regex\":\"^/([^/]+)/stores/([^/]+)$\",\"paramNames\":[\"cacheKey\",\"country\"]},{\"path\":\"/:cacheKey/stores/:country/:stateprovince\",\"regex\":\"^/([^/]+)/stores/([^/]+)/([^/]+)$\",\"paramNames\":[\"cacheKey\",\"country\",\"stateprovince\"]},{\"path\":\"/:cacheKey/stores/:country/:stateprovince/:city\",\"regex\":\"^/([^/]+)/stores/([^/]+)/([^/]+)/([^/]+)$\",\"paramNames\":[\"cacheKey\",\"country\",\"stateprovince\",\"city\"]}],\"staticRoutes\":[{\"path\":\"/\"}]}";import * as Sentry from '@sentry/nextjs';

const {
    sharedSentryReplayIntegrationConfig,
} = require('../../libs/common-next/shared-sentry.replayIntegration.config');

const { initSentry } = require('../../libs/common-next/shared-sentry.client.config');

initSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

    initialScope: {
        tags: {
            application_name: 'HCP',
        },
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE) || 0.015,

    // Capture Replay for 10% of all sessions
    // Capture 100% of sessions with an error
    replaysSessionSampleRate: Number(process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE) || 0.1,
    replaysOnErrorSampleRate: Number(process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE) || 1.0,

    // NOTE: The BrowserTracing and Replay was commented out to avoid performance issue
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
        Sentry.replayIntegration(sharedSentryReplayIntegrationConfig),
        Sentry.httpClientIntegration(),
    ],

    sendDefaultPii: true,
});

export default Sentry;
